import React, { useCallback, useContext, useEffect, useReducer } from 'react';
import CallObjectContext from '../CallObjectContext';
import { CAM_OR_MIC_ERROR, FATAL_ERROR, initialState, isLocal, PARTICIPANTS_CHANGE, reducer } from '../store';
import TileCall from './TileCall';
import { useNavigate } from 'react-router-dom';
import Error from './Error';

const Call = ({ roomUrl }) => {
  const callObject = useContext(CallObjectContext);
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (!callObject) return;

    const events = [
      'participant-joined',
      'participant-updated',
      'participant-left'
    ];

    function handleNewParticipantsState(event) {
      event && console.log(event);
      dispatch({
        type: PARTICIPANTS_CHANGE,
        participants: callObject.participants()
      });
    }

    // Use initial state
    handleNewParticipantsState();

    // Listen for changes in state
    for (const event of events) {
      callObject.on(event, handleNewParticipantsState);
    }

    // Stop listening for changes in state
    return function cleanup() {
      for (const event of events) {
        callObject.off(event, handleNewParticipantsState);
      }
    };
  }, [callObject]);

  useEffect(() => {
    if (!callObject) return;

    function handleCameraErrorEvent(event) {
      console.log(event);
      dispatch({
        type: CAM_OR_MIC_ERROR,
        message:
          (event && event.errorMsg && event.errorMsg.errorMsg) || 'Unknown'
      });
    }

    // We're making an assumption here: there is no camera error when callObject
    // is first assigned.

    callObject.on('camera-error', handleCameraErrorEvent);

    return function cleanup() {
      callObject.off('camera-error', handleCameraErrorEvent);
    };
  }, [callObject]);

  useEffect(() => {
    if (!callObject) return;

    function handleErrorEvent(e) {
      console.log(e);
      dispatch({
        type: FATAL_ERROR,
        message: (e && e.errorMsg) || 'Unknown'
      });
      //navigate('/error');
    }

    // We're making an assumption here: there is no error when callObject is
    // first assigned.

    callObject.on('error', handleErrorEvent);

    return function cleanup() {
      callObject.off('error', handleErrorEvent);
    };
  }, [callObject, navigate]);

  /**
   * Starts leaving the current call.
   */
  const startLeavingCall = useCallback(() => {
    if (!callObject) return;
    // If we're in the error state, we've already "left", so just clean up
    if (state.camOrMicError || state.fatalError) {
      callObject.destroy().then(() => {
        // setRoomUrl(null);
        // setCallObject(null);
        // setAppState(STATE_IDLE);
        console.log('DESTROYED');
        navigate('/');
      });
    } else {
      //setAppState(STATE_LEAVING);
      callObject.leave()
        .then(() => navigate('/'));
      console.log('LEAVE');

    }
  }, [callObject, state, navigate]);

  const switchCamera = async () => {
    if (!callObject) return;
    try {
      const enumDevices = await callObject.enumerateDevices();
      let devices = [];
      devices = [...enumDevices.devices];
      //console.log(devices);
      const deviceToSwitch = devices.filter(device => device.kind === 'videoinput' && device.deviceId !== state.activeMediaDevices.video.deviceId)[0];
      if (!deviceToSwitch) {
        console.log('There is no other camera to switch');
        return;
      }
      const deviceInfo = await callObject.setInputDevicesAsync({
        videoSource: deviceToSwitch.deviceId
      });
      console.log(deviceInfo);
    } catch (error) {
      console.log(error);
    }
  };

  const getTiles = () => {
    let tiles = [];
    Object.entries(state.callItems).forEach(([id, callItem]) => {
      const tile = (
        <TileCall
          key={id}
          videoTrackState={callItem.videoTrackState}
          audioTrackState={callItem.audioTrackState}
          isLocalPerson={isLocal(id)}
          disableCornerMessage={true}
          leaveClickHandler={startLeavingCall}
          switchCameraClickHandler={switchCamera}
        />
      );
      tiles.push(tile);
    });
    return tiles;
  };
  const tiles = getTiles();

  if (state.fatalError) {
    return <Error error={state.fatalError} />
  }

  return (
    <>
      {tiles}
    </>
  );
};
export default Call;